/**
 * Subimods Support About — pinned scroll timeline
 * Root: [data-sm-support-about]
 * Docs: SM-SUPPORT-PAGES.md
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-sm-support-about]';
  var REDUCE_MQ = '(prefers-reduced-motion: reduce)';

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function initRoot(root) {
    var timeline = root.querySelector('[data-sm-about-timeline]');
    if (!timeline) return;

    var track = timeline.querySelector('[data-sm-about-track]');
    var stage = timeline.querySelector('[data-sm-about-stage]');
    var chapters = Array.prototype.slice.call(
      timeline.querySelectorAll('[data-sm-about-chapter]')
    );
    if (!track || !stage || !chapters.length) return;

    var yearEl = timeline.querySelector('[data-sm-about-year]');
    var titleEl = timeline.querySelector('[data-sm-about-title]');
    var bodyEl = timeline.querySelector('[data-sm-about-body]');
    var mediaEl = timeline.querySelector('[data-sm-about-media]');
    var imageEl = timeline.querySelector('[data-sm-about-image]');
    var currentEl = timeline.querySelector('[data-sm-about-current]');
    var progressEl = timeline.querySelector('[data-sm-about-progress]');
    var ticks = Array.prototype.slice.call(
      timeline.querySelectorAll('[data-sm-about-tick]')
    );

    var activeIndex = -1;
    var ticking = false;
    var reduceMotion = window.matchMedia(REDUCE_MQ).matches;

    function chapterBodyHtml(chapter) {
      var body = chapter.querySelector('[data-sm-about-chapter-body]');
      return body ? body.innerHTML : '';
    }

    var copyEl = timeline.querySelector('.sm-support-about-timeline__copy');

    function applyChapter(index) {
      var chapter = chapters[index];
      var year = chapter.getAttribute('data-year') || '';
      var title = chapter.getAttribute('data-title') || '';
      var image = chapter.getAttribute('data-image') || '';
      var imageAlt = chapter.getAttribute('data-image-alt') || title;

      if (yearEl) yearEl.textContent = year;
      if (titleEl) titleEl.textContent = title;
      if (bodyEl) bodyEl.innerHTML = chapterBodyHtml(chapter);
      if (currentEl) currentEl.textContent = pad2(index + 1);

      if (mediaEl && imageEl) {
        if (image) {
          imageEl.src = image;
          imageEl.alt = imageAlt;
          mediaEl.hidden = false;
          timeline.classList.add('has-media');
        } else {
          imageEl.removeAttribute('src');
          imageEl.alt = '';
          mediaEl.hidden = true;
          timeline.classList.remove('has-media');
        }
      }

      chapters.forEach(function (node, i) {
        node.classList.toggle('is-active', i === index);
      });
      ticks.forEach(function (tick, i) {
        tick.classList.toggle('is-active', i === index);
        if (i === index) {
          tick.setAttribute('aria-current', 'true');
          if (typeof tick.scrollIntoView === 'function') {
            tick.scrollIntoView({
              inline: 'center',
              block: 'nearest',
              behavior: reduceMotion ? 'auto' : 'smooth'
            });
          }
        } else {
          tick.removeAttribute('aria-current');
        }
      });

      if (progressEl) {
        var ratio = chapters.length <= 1 ? 1 : index / (chapters.length - 1);
        progressEl.style.transform = 'scaleY(' + ratio + ')';
      }

      timeline.setAttribute('data-active-index', String(index));
    }

    function setActive(index, force) {
      var next = Math.max(0, Math.min(chapters.length - 1, index));
      if (!force && next === activeIndex) return;

      var animate = !force && activeIndex >= 0 && !reduceMotion && copyEl;
      activeIndex = next;

      if (!animate) {
        applyChapter(activeIndex);
        return;
      }

      copyEl.classList.add('is-switching');
      if (mediaEl) mediaEl.classList.add('is-switching');
      window.setTimeout(function () {
        applyChapter(activeIndex);
        copyEl.classList.remove('is-switching');
        if (mediaEl) mediaEl.classList.remove('is-switching');
      }, 160);
    }

    function syncFromScroll() {
      if (reduceMotion) return;

      var rect = track.getBoundingClientRect();
      var trackHeight = track.offsetHeight;
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var scrollable = Math.max(1, trackHeight - viewport);
      var traveled = Math.min(scrollable, Math.max(0, -rect.top));
      var progress = traveled / scrollable;
      var index = Math.round(progress * (chapters.length - 1));
      setActive(index);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncFromScroll();
        ticking = false;
      });
    }

    function jumpTo(index) {
      var next = Math.max(0, Math.min(chapters.length - 1, index));
      if (reduceMotion) {
        var target = chapters[next];
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setActive(next, true);
        return;
      }

      var trackTop = track.getBoundingClientRect().top + window.pageYOffset;
      var trackHeight = track.offsetHeight;
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var scrollable = Math.max(1, trackHeight - viewport);
      var ratio = chapters.length <= 1 ? 0 : next / (chapters.length - 1);
      var y = trackTop + scrollable * ratio;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    ticks.forEach(function (tick) {
      tick.addEventListener('click', function () {
        var idx = parseInt(tick.getAttribute('data-sm-about-tick'), 10);
        if (!isNaN(idx)) jumpTo(idx);
      });
    });

    function applyMode() {
      reduceMotion = window.matchMedia(REDUCE_MQ).matches;
      timeline.classList.toggle('is-reduced', reduceMotion);
      if (reduceMotion) {
        setActive(0, true);
      } else {
        syncFromScroll();
      }
    }

    applyMode();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (window.matchMedia(REDUCE_MQ).addEventListener) {
      window.matchMedia(REDUCE_MQ).addEventListener('change', applyMode);
    }

    setActive(0, true);
    syncFromScroll();
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector(ROOT_SEL)) {
      initRoot(event.target.querySelector(ROOT_SEL));
    } else if (event.target && event.target.matches && event.target.matches(ROOT_SEL)) {
      initRoot(event.target);
    }
  });
})();
